var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
import IconButton from '../../Buttons/IconButton/IconButton';
import Spacer from '../../Layout/Spacer/Spacer';
import Box from '../../Layout/Flex/Box';
const ExpansionPanelContainer = styled.div `
  position: relative;
  width: ${props => props.width};
  ${props => props.isBlock &&
    css `
      box-sizing: border-box,
      display: block;
      width: auto;
    `};
  overflow: hidden;
  box-shadow: ${props => (props.box ? props.theme.boxes.boxShadow : 'none')};
  border: none;
  border-radius: ${props => props.theme.borders.borderRadius};
  margin-left: ${props => props.noMargin ? '0' : props.theme.paddingsMargins.themeMenuMarginSingle};
  margin-right: ${props => props.noMargin ? '0' : props.theme.paddingsMargins.themeMenuMarginSingle};
  ${props => props.isContent &&
    css `
      margin-left: 0;
      margin-right: 0;
      padding: 0;
    `};
  transition: all 200ms ease-in;
`;
const ExpansionPanelAction = styled.div `
  box-sizing: border-box;
  background-color: ${props => props.backgroundColor};
  padding: ${props => props.noPadding ? '0' : props.theme.paddingsMargins.themeMenuPadding};
  padding-left: ${props => props.noPadding ? '0' : props.theme.paddingsMargins.themePaddingSingle};
  padding-right: ${props => props.noPadding ? '0' : props.theme.paddingsMargins.themePaddingSingle};
  padding-bottom: ${props => props.noPadding ? '0' : props.active ? 0 : props.theme.paddingsMargins.themeMenuPadding};
  cursor: pointer;
  display: inline-flex;
  width: 100%;
  user-select: none;
  justify-content: ${props => props.arrowPosition === 'end' ? 'space-between' : 'flex-start'};
  align-items: center;
`;
const ExpandedPanel = styled.div `
  padding: ${props => props.noPadding ? '0' : props.theme.paddingsMargins.themePadding};
  padding-top: 0;
  background-color: white;
  font-family: ${props => props.theme.fonts.fontFamily};
  transition: all 200ms ease-in;
`;
const ButtonAnimator = styled.div `transition: transform 200ms ease-in;`;
const ExpansionPanel = (_a) => {
    var { color = 'main', isBlock = false, width = 'fit-content', text, textSize = 'article', textWeight = 'normal', children, arrowPosition = 'end', icon = 'arrowDown', box = false, isContent = false, noPadding = false, noMargin = false, backgroundColor = '', onClick = () => { }, isOpen = false, manageVisibility, component } = _a, props = __rest(_a, ["color", "isBlock", "width", "text", "textSize", "textWeight", "children", "arrowPosition", "icon", "box", "isContent", "noPadding", "noMargin", "backgroundColor", "onClick", "isOpen", "manageVisibility", "component"]);
    const [active, setActive] = useState(isOpen);
    const theme = useTheme();
    useEffect(() => {
        setActive(isOpen);
    }, [isOpen]);
    return (_jsxs(ExpansionPanelContainer, Object.assign({ width: width, isContent: isContent, noMargin: noMargin, onClick: (e) => onClick(e), style: active
            ? {
                backgroundColor,
                marginTop: theme.paddingsMargins.themeMenuMarginSingle,
                marginBottom: theme.paddingsMargins.themeMenuMarginSingle
            }
            : {
                marginTop: 0,
                marginBottom: 0
            }, box: box, isBlock: isBlock }, props, { children: [_jsxs(ExpansionPanelAction, Object.assign({ backgroundColor: backgroundColor, arrowPosition: arrowPosition, noPadding: noPadding, active: active, onClick: manageVisibility ? () => manageVisibility() : () => setActive(!active) }, { children: [_jsx(Typography, Object.assign({ size: textSize, color: color, weight: textWeight }, { children: text })), _jsx(Spacer, {}), _jsxs(Box, Object.assign({ alignItems: 'center' }, { children: [component, component && _jsx(Spacer, { half: true }), _jsx(ButtonAnimator, Object.assign({ style: { transform: active ? 'rotate(-180deg)' : 'rotate(0deg)' } }, { children: _jsx(IconButton, { icon: icon, color: color }) }))] }))] })), _jsx(ExpandedPanel, Object.assign({ noPadding: noPadding, style: active
                    ? {
                        backgroundColor,
                        height: 'auto',
                        opacity: 1,
                        display: 'block',
                        marginTop: theme.paddingsMargins.themeMenuMarginSingle
                    }
                    : { height: '0px', opacity: 0, display: 'none', marginTop: 0 } }, { children: children }))] })));
};
export default ExpansionPanel;
